import { filter, isEmpty, get, some } from 'lodash'
import { Query } from '../generated/gatsby.types'
import { parentKey as getParentKey } from '.'

/**
 * Filters the allContentful\<section> array of `data` such that all remaining
 * entries match the country, language, region, sector, and topic tagging
 * of the parent page.
 *
 * Each entry must have at least one tag in common with the page, but doesn't
 * have to match exactly. For example, `countries: ['usa', 'mexico']` matches
 * `countries: ['brazil', 'mexico']`
 */
export default (data: Query, section: string) => {
  const parentKey: string = getParentKey(data)

  const matchContentWithPageData = (node: Query, type: string) => {
    if (isEmpty(data[parentKey][type])) return true
    return some(node[type], (entry) => some(data[parentKey][type], entry))
  }
  const taxonomyFilteredContent = filter(
    get(data, `allContentful${section}.nodes`, []),
    (node) =>
      matchContentWithPageData(node, 'countries') &&
      matchContentWithPageData(node, 'languages') &&
      matchContentWithPageData(node, 'regions') &&
      matchContentWithPageData(node, 'sectors') &&
      matchContentWithPageData(node, 'topics')
  )

  return taxonomyFilteredContent
}
